export const iconFontAwesomeShapesTicketSimple = (
	<i className="fa-solid fa-ticket-simple"></i>
);
